export enum AuthExceptionType {
  Credentials,
  Version,
  LoadingBasicData,
  Unknown,
  Network
}
